/*================Utils====================*/
window.util = window.util || {}
window.paceOptions = {restartOnPushState: false}; 
// Passive event listeners
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};


/*================ Modules ================*/
/* global js */
var cartData = {};
var htoStorage = JSON.parse(window.localStorage.getItem('products'));
var cartCount = 0;

var singleHTOVal = theme.custom.htoSingleProduct;
var singleHTOArr = singleHTOVal.split(', ');

document.addEventListener('DOMContentLoaded', function() {
  checkInvalidCartChild(); 
  $('body').attr('data-online', isWithinBusinessHours(theme.custom.hoursOn, theme.custom.hoursOff));
  // force offline online
  const params = new URLSearchParams(window.location.search);
  if (params.get('online') === 'true') {
    $('body').attr('data-online', 'true');
  }
  if (params.get('online') === 'false') {
    $('body').attr('data-online', 'false');
  }
  //console.log(navigator.userAgent);
  $('body').on('click', '.discountLink', function() {
    var confirmMsg = $(this).attr('data-msg');
    var discountLink = $(this).attr('href');
    Swal.fire({
        position: 'top',
        title: confirmMsg,
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "Proceed",
        cancelButtonText: "Cancel",
        type: 'warning',
        reverseButtons: true,
        customClass: {
            cancelButton: 'btn btn-sm btn-remove',
            denyButton: 'btn btn-sm btn-remove',
            confirmButton: 'btn btn-sm btn-primary'
        }
    }).then(function(event) {
        if (event.isConfirmed == true) {
            window.location.href = discountLink;
        }
    });  
    return false;
  });


  
  $('body').on('click', '.inline-pop', function() {
    $.magnificPopup.open({
        items: {
          src: $(this).attr('href'),
          type: 'inline',
          callbacks: {
          }
        }
    });
    return false;
  });

  $('body').on('click', '.ajax-pop', function() {
    $.magnificPopup.open({
        items: {
          src: $(this).attr('href'),
          type: 'ajax',
          callbacks: {
          }
        }
    });
    return false;
  });

  $('body').on('click', '.tipTrigger', function(event) {
    
    // var thisParent = $(this).parent();
    
    // setTimeout(function() {
    //   var parentClass = thisParent.attr('class');
    // console.log(parentClass);
    //   if (thisParent.hasClass('kuCollapse')) {
    //      thisParent.removeClass('kuCollapse');
    //     thisParent.addClass('kuExpand');
    //   } else {
    //     thisParent.removeClass('kuExpand');
    //     thisParent.addClass('kuCollapse');
    //   }
    // }, 600);
    event.stopPropagation();
    $.magnificPopup.open({
        items: {
          src: $(this).attr('href'),
          type: 'ajax',
          callbacks: {
          }
        }
    });
    event.stopPropagation();
  }); 
  $('body').on('click', '.kuFilterHead', function(click) {
    $(this).closest('.kuFilterBox').toggleClass('collapse');
  });   


  if( window.location.href.indexOf("?q=hto")>-1 ){
    tryRunTakeAQuiz()
  }
  if (window.location.pathname.indexOf('/pages/home-try-on-glasses') > -1) {
    tryRunTakeAQuiz()
  }

});  

$(document).click(function() {
  $('.dropdown').removeClass('exp');   
});

$('body').on('click', '.dropdown-toggle', function(event) {
  if ($(this).closest('.dropdown').hasClass('exp')) {
    $(this).closest('.dropdown').removeClass('exp');      
  } else {
    $('.dropdown.exp').removeClass('exp');  
    $(this).closest('.dropdown').addClass('exp'); 
  }
  event.stopPropagation();
});
$('body').on('click', '.expCollapse', function(event) {
  $(this).closest('.seoDescription ').toggleClass('exp');      
});

$('body').on('click', '.nav_quize_text', function(event) {
  return false;
});
var body = $("html, body");
$('body').on('click', '.scroll-top a', function() {
  body.stop().animate({scrollTop:0}, 600, 'swing', function() { 
  });
  return false; 
});

const supportsHover = window.matchMedia('(hover: hover)').matches;
// Use mouseover on desktops, touchend/click on touch devices
const triggerEvent = supportsHover ? 'mouseover click' : 'touchend click';

$('body').on(triggerEvent, '.customCard .c-color-swatches__swatch', function (e) {
  e.preventDefault(); // stop default link or scroll
  e.stopPropagation(); // avoid bubbling up

  const $swatch = $(this);
  const $card = $swatch.closest('.customCard');

  const imgSrc = $swatch.data('image');
  const varURL = $swatch.data('url');
  const pColor = $swatch.data('handle');
  const pColorTitle = $swatch.attr('title') || '';
  const pType = $swatch.closest('.product-card').data('type');
  const pHref = $card.find('.overlayLink').data('href') || '';
  const pSuffix = $card.find('.overlayLink').data('suffix') || '';


  $swatch.closest('[data-grid-swatch]').find('[data-selected-swatch]').text(pColorTitle);
console.log('pColorTitle', pColorTitle);


  if (!imgSrc || !varURL || !pColor) return;

  // Swap image (ensure repaint)
  $card.find('.htoOverlayBox').removeClass('open');
  $card.find('.product-card__image').attr({
    srcset: imgSrc,
    src: imgSrc.split(',')[0].trim()
  });

  // OOS visual update
  $card.toggleClass('oos', $swatch.hasClass('unavailable'));

  // Update href links
  const colorQuery = `?color=${encodeURIComponent(pColor)}&${pSuffix}`;
  const finalURL = (pType === 'collection' ? pHref : varURL) + colorQuery;
  $card.find('.overlayLink, .btnLink')
    .attr({ href: finalURL, 'data-color': pColor });

  // Variant JSON handling
  let variants = [];
  try {
    variants = JSON.parse($card.find('.variantJson').text() || '[]');
  } catch (err) {
    console.warn('Invalid JSON:', err);
  }

  // Reset + mark sizes
  const $sizes = $card.find('.htoSize label').addClass('unAvailable').removeClass('soldOut');
  variants.forEach(v => {
    const eyeSize = (v.title || '').replace(/[^0-9]/g, '');
    const hasColor = (v.titlehandle || '').includes(pColor);
    if (hasColor) {
      $sizes.filter(`[data-eye-size="${eyeSize}"]`)
        .attr('data-sku', v.sku)
        .removeClass('unAvailable');
    }

    const matchesColor =
      (v.option1 || '').includes(pColorTitle) ||
      (v.option2 || '').includes(pColorTitle);
    const matchesSize =
      (v.option1 || '').includes(eyeSize) ||
      (v.option2 || '').includes(eyeSize);

    if (!v.available && matchesColor && matchesSize) {
      $sizes.filter(`[data-eye-size="${eyeSize}"]`).addClass('soldOut');
    }
  });

  // Update visual state
  $card.find('.c-color-swatches__swatch').removeClass('active');
  $swatch.addClass('active');

  checkHTOGrid($card, $card.data('handle'), pColorTitle);
  checkHTOItem();

  //console.log('Swatch event fired:', triggerEvent);
});



$('.customCard').each(function() {
  $(this).find('.c-color-swatches__swatch').not('.unavailable').first().trigger('click');
});


$('body').on('click', '.htoLandingPage2 .page_section_faq h5', function() {
    $(this).next('p').toggle();
    $(this).toggleClass('exp');
});
$('body').on('click', '#banner-text-container h1.category', function() {
    $('#banner-text-container').toggleClass('exp');
});

function tryRunTakeAQuiz() {
  $('body').addClass('quizOpen');
  if ($('.quizSection > *').length == 0) {
    // ajax load quiz if not present
    $('body').addClass('ajaxLoading');

    //var quizURL = '/pages/quiz-section';
    var quizURL = '/pages/new-quiz';
    
    $('.quizSection').load(quizURL, function() {
      $('body').removeClass('ajaxLoading');
      recalculatesHeaderHorFixHeader();
    });
  }
  return false;
}

//sample usage
//replaceUrlParam(window.location.href, 'variant', xxx);
function replaceUrlParam(url, paramName, paramValue)
{
    if (paramValue == null) {
        paramValue = '';
    }
    var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
    if (url.search(pattern)>=0) {
        return url.replace(pattern,'$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/,'');
    return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
}

//sample usage
//removeParams(parameter);
function removeParams(url, sParam) {
   var url = window.location.href.split('?')[0] + '?';
   var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

   for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] != sParam) {
         url = url + sParameterName[0] + '=' + sParameterName[1] + '&'
      }
   }
   return url.substring(0, url.length - 1);
}

// sample usage
// var filterQuery = getQueryParams(document.location.search);
//var filterColor = filterQuery.color;
function getQueryParams(qs) {
    qs = qs.split('+').join(' ');
    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;
    while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }
    return params;
}


function slugify(str)
{
    str = str.replace(/^\s+|\s+$/g, '');

    // Make the string lowercase
    str = str.toLowerCase();

    // Remove accents, swap ñ for n, etc
    var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
    var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    // Remove invalid chars
    str = str.replace(/[^a-z0-9 -]/g, '') 
    // Collapse whitespace and replace by -
    .replace(/\s+/g, '-') 
    // Collapse dashes
    .replace(/-+/g, '-'); 

    return str;
}


$(document).ready(function() {
  var isMobile = {
      Android: function() {
          return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function() {
          return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
      },
      any: function() {
          return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
      }
  };

  if( isMobile.any() )  {
    $('body').addClass('mobileBody');
  };


});

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};  
var zenLoaded = false;
var afterpayLoaded = false;
var hjLoaded = true;
var klLoaded= false;


window.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    runKlaviyo();
    runZenDesk();
    runHotJar();
    runAfterpay();
  }, 7000);
});


document.addEventListener('scroll', delayedLoadEvent);
document.addEventListener('mousemove', delayedLoadEvent);
document.addEventListener('touchstart', delayedLoadEvent);

function delayedLoadEvent(event) {
  runKlaviyo();
  runZenDesk();
  runHotJar();
  runAfterpay();
};


function handleScroll() {
  //console.log('handleScroll'); 
  // if ($('.boost-pfs-filter-product-item').length > 0) {
  //   var pageQuery = getQueryParams(document.location.search);
  //   var pageNum = '1';
  //   var visiblePageNum = 1;
  //   if (pageQuery.page === undefined) {
  //       pageNum = '1';
  //   } else {
  //       pageNum = pageQuery.page;
  //   }

  //   $('.boost-pfs-filter-product-item').each(function() {
  //       if ($(this).isInViewport()) {
  //         visiblePageNum = $(this).attr('data-page');
  //         //console.log($(this).find('.boost-pfs-filter-product-item-title').text());
  //         //return false;
  //       }
  //   });
  //   if (visiblePageNum != pageNum) {
  //       var modifiedURL = replaceUrlParam(window.location.href, 'page', visiblePageNum);
  //       if (visiblePageNum == 1) {
  //           modifiedURL = removeParams(window.location.href, 'page');
  //       }
  //       history.replaceState(null, null, modifiedURL);
  //   }
  // }
}

function debounceX(method, delay) {
    clearTimeout(method._tId);
    method._tId= setTimeout(function(){
        method();
    }, delay);
}
function checkHTOGrid(elem, handle, color) {
  const $grid = $(elem);
  const $labels = $grid.find('.htoSize label');
  const $overlay = $grid.find('.htoOverlayBox');

  $labels.removeClass('disableHTO');
  $overlay.show();

  for (const entry of disableHto) {
    const handleMatch = entry.handle && entry.handle === handle;
    const colorMatch = entry.Color && entry.Color.split(', ').includes(color);

    if (handleMatch && colorMatch) {
      const widthStr = entry.width || '';
      
      if (!widthStr) {
        $overlay.hide();
        return;
      }

      const widthArr = widthStr.split(', ');
      for (const width of widthArr) {
        $labels.filter(`[data-size="${width}"]`).addClass('disableHTO');
      }

      const available = $labels
        .not('.disableHTO')
        .not('.unAvailable')
        .not('.soldOut').length;

      if (available === 0) {
        $overlay.hide();
      } else {
        $overlay.show();
      }

      return; // Exit early after first match
    }
  }
}


function runZenDesk() {
  (function e(){var e=document.createElement("script");e.type="text/javascript",e.id="ze-snippet",e.async=true,e.src="https://static.zdassets.com/ekr/snippet.js?key=cac64713-b78a-4a7b-aa3b-8921b1b24310";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();
  
  setTimeout(function() {
      
    if (typeof zE !== 'undefined') {
      console.log('Zendesk snippet is loaded');
      //var zDHTML = '<div class="customZD"><div class="zDTrigger"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20" xml:space="preserve" aria-hidden="true"><g></g><g></g><g></g><g><g><g><path d="M11,12.3V13c0,0-1.8,0-2,0v-0.6c0-0.6,0.1-1.4,0.8-2.1c0.7-0.7,1.6-1.2,1.6-2.1c0-0.9-0.7-1.4-1.4-1.4 c-1.3,0-1.4,1.4-1.5,1.7H6.6C6.6,7.1,7.2,5,10,5c2.4,0,3.4,1.6,3.4,3C13.4,10.4,11,10.8,11,12.3z"></path><circle cx="10" cy="15" r="1"></circle></g><path d="M10,2c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S5.6,2,10,2 M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0 L10,0z"></path></g></g></svg>Help</div><div class="zDOptions"><span onclick="openHelpCenter()">Help Center</span><span onclick="openContactForm()">Get In Touch</span></div></div>';
      //$('body').append(zDHTML);
    } else {
      console.log('Zendesk snippet is not loaded');

    }


  }, 1000);


  zenLoaded = true;
}
function openHelpCenter() {
  zE('webWidget', 'updateSettings', { helpCenter: { suppress: false }, contactForm: { suppress: true } });
  zE('webWidget', 'open');
  console.log('Help Center opened');

}

// Open the Contact Form
function openContactForm() {
  zE('webWidget', 'updateSettings', { contactForm: { suppress: false }, helpCenter: { suppress: true } });
  zE('webWidget', 'open'); // Open the widget
  console.log('Contact Form opened');
}



function runAfterpay() {
  if (document.body.classList.contains('template-product') == false) {
    return false;
  }
  if (typeof Afterpay != 'undefined') {
    return false;
  }
  if (afterpayLoaded == true) {
    return false;
  }
  //console.log('runAfterpay');
  (function e(){var e=document.createElement("script");e.type="text/javascript",e.async=true,e.src="https://static.afterpay.com/shopify-afterpay-javascript.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();
  $('.afterpay-paragraph').remove();
  $('afterpay-placement').remove();
  $('.afterpayPlaceholder').remove();
  afterpayLoaded = true;
}
function runZenDesk() {
  if (zenLoaded) {
    return false;
  }
  //console.log('runZenDesk');
  (function e(){var e=document.createElement("script");e.type="text/javascript",e.id="ze-snippet",e.async=true,e.src="https://static.zdassets.com/ekr/snippet.js?key=cac64713-b78a-4a7b-aa3b-8921b1b24310";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();
  zenLoaded = true;
}

function runKlaviyo() {
  if (klLoaded) {
    return false;
  }
  (function e(){var e=document.createElement("script");e.type="text/javascript",e.async=true,e.src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=PR3pfr";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();
  klLoaded = true;

}
function runHotJar() {
  if (hjLoaded) {
    return false;
  }  
  (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:1913640,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  hjLoaded = true;    
}  

function checkInvalidCartChild() {
  $.ajaxSetup({
    async: false,
  });
  var cartVar;
  $.ajax({
    type: 'GET',
    url: 'https://opticsoutfitter.com/cart.json',
    dataType: 'json',
    success: function(data) {
      //console.log(data);
      cartVar = data.items;
    }
  });

  var invalidKey = [];
  $.each(cartVar, function(index, value) {
    if (value.properties['_Timestamp'] != undefined && value.properties['_Product ID'] != undefined) {
      var currentTS = value.properties['_Timestamp'];
      var currentPID = value.properties['_Product ID'];
      var parentFound = false;

      $.each(cartVar, function(index, value) {
        if (value.id == currentPID || value.product_id == currentPID) {
          if (currentTS == value.properties['_Timestamp']) {
            parentFound = true
          }
        }  
      });
      if (parentFound == false) {
        invalidKey.push(value.key);
      }
    }
  });

  invalidKey = $.unique(invalidKey);
  //console.log('invalidKey');
  //console.log(invalidKey);


  if (invalidKey.length > 0) {
    Swal.fire({
      title: 'Cart Error',
      text: 'Invalid items will be removed from cart',
      showCancelButton: false,
      confirmButtonText: "Ok",
      cancelButtonText: "Go Back",
      type: 'warning',
      reverseButtons: true,
      allowOutsideClick: false,
      customClass: {
        cancelButton: 'btn btn-sm btn-remove',
        denyButton: 'btn btn-sm btn-remove',
        confirmButton: 'btn btn-sm btn-primary'
      }
    }).then(function(del) {
      if (del.isConfirmed) {
        console.log(invalidKey);
        var xdata = {
          updates: {}
        };
        $.each(invalidKey, function(index, value) {
          var cartKeyToRemove = value;
          xdata.updates[cartKeyToRemove] = 0;
        });
        console.log(xdata);
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: xdata,
          dataType: 'json',
          success: function() {

          }
        });
        location.reload();


      }
    })
  }

  $.ajaxSetup({
    async: true,
  });
}  


function isWithinBusinessHours(startHour, endHour) {
    let now = new Date();

    // Define business hours as strings in AM/PM format
    const START_TIME = startHour;
    const END_TIME = endHour;

    // Function to convert "7 AM" / "7 PM" to 24-hour format
    function convertTo24Hour(timeStr) {
        let [time, period] = timeStr.toUpperCase().split(" ");
        let hour = parseInt(time, 10);

        if (period === "PM" && hour !== 12) {
            hour += 12; // Convert PM hours (except 12 PM)
        } else if (period === "AM" && hour === 12) {
            hour = 0; // Convert 12 AM to 0
        }

        return hour;
    }

    const START_HOUR = convertTo24Hour(START_TIME);
    const END_HOUR = convertTo24Hour(END_TIME);

    //console.log(START_HOUR, END_HOUR);

    // Get the current hour in MST (UTC-7)
    let hourFormatter = new Intl.DateTimeFormat("en-US", { 
        timeZone: "America/New_York", 
        hour12: false, 
        hour: "numeric" 
    });

    let hour = parseInt(hourFormatter.format(now), 10); // Convert to integer

    // Check if the current time is within business hours
    return hour >= START_HOUR && hour < END_HOUR;
}


  /* ---------- CONFIG ---------- */
  const DAY = theme.custom.smsBuffer;
  const ENABLED = theme.custom.smsExit;
  const ONLINE_KL_FORM = theme.custom.onlineKLSMS;
  const OFFLINE_KL_FORM = theme.custom.offlineKLSMS;
  const TIMEOUT = theme.custom.exitDelay;

  const ONLINE_SMS = theme.custom.onlineSMS;
  const OFFLINE_SMS = theme.custom.offlineSMS;

  const ONLINE_SMS_CHAT = theme.custom.onlineSMSChat;
  const OFFLINE_SMS_CHAT = theme.custom.offlineSMSChat;

  const ONLINE_KL_FORM_CHAT = theme.custom.onlineKLSMSChat;
  const OFFLINE_KL_FORM_CHAT = theme.custom.offlineKLSMSChat;

  const STORAGE_KEY_LAST_FIRED = 'mobileExitIntentLastFired';   
  const STORAGE_KEY_PAGE_VIEWS = 'sessionPageViews';            
  const DAYS = DAY * 24 * 60 * 60 * 1000;
  const MIN_PAGE_VIEWS = theme.custom.smsPV;    


  const TOP_EDGE_PX       = 0;    // desktop: Y ≤ this is “above the viewport”
  const SIDE_EDGE_PX      = 0;    // desktop: X ≤ 0 or X ≥ vw ⇒ side hover
  const MOBILE_TOP_PX     = 120;  // mobile: “near top” after fast upward scroll
  const MOBILE_DELTA_PX   = 60;   // scroll‑up distance that counts as “fast”
  const MOBILE_DELTA_MS   = 200;  // … within this many ms                         

  /*  PAGE-VIEW COUNTER  */
  // Count every full page
  const viewsSoFar = parseInt(sessionStorage.getItem(STORAGE_KEY_PAGE_VIEWS), 10) || 0;
  sessionStorage.setItem(STORAGE_KEY_PAGE_VIEWS, viewsSoFar + 1);

  /* EXIT-INTENT LOGIC  */
  const now        = Date.now();
  const lastFired  = localStorage.getItem(STORAGE_KEY_LAST_FIRED);
  let   firedThisSession = false;
  let lastScrollTop = 0;

  function shouldFireIntent() {
    const pageViewsOK   = (parseInt(sessionStorage.getItem(STORAGE_KEY_PAGE_VIEWS), 10) >= MIN_PAGE_VIEWS);
    const notThrottled  = (!lastFired || now - parseInt(lastFired, 10) > DAYS);
    return !firedThisSession && pageViewsOK && notThrottled;
  }

  function fireExitIntent(src) {
    //alert('fireExitIntent'+src+'||'+shouldFireIntent());
    if (ENABLED && shouldFireIntent()) {
      firedThisSession = true;
      localStorage.setItem(STORAGE_KEY_LAST_FIRED, now.toString());
      var onlineHours = document.body.getAttribute('data-online');

      if (onlineHours === 'true') {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', ONLINE_KL_FORM]);
      } 
      if (onlineHours === 'false') {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', OFFLINE_KL_FORM]);
      }
    }  
  }
  window.addEventListener('load', () => {
    //console.log('viewsSoFar:'+viewsSoFar, shouldFireIntent());
    setTimeout(() => {
      /* scroll-up within 100 px of top */
      let lastY     = window.scrollY;
      let lastTime  = performance.now();
      window.addEventListener('scroll', () => {


        const now  = performance.now();
        const y    = window.scrollY;
        const dy   = lastY - y;          // positive = scrolling up
        const dt   = now - lastTime;

        if (
          dy > MOBILE_DELTA_PX &&        // scrolled up fast enough
          dt < MOBILE_DELTA_MS  &&
          y  < MOBILE_TOP_PX             // landed near the top
        ) {
          //console.log('fast scroll-up', shouldFireIntent());
          fireExitIntent('scroll-up');
        }

        lastY    = y;
        lastTime = now;
      });
      /* tab close */
      window.addEventListener('pagehide', () => fireExitIntent('pagehide'));
      /*  tab-blur fallback */
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') fireExitIntent('visibilitychange');
      });

      document.addEventListener('mouseout', (e) => {
        if (
          !e.toElement && !e.relatedTarget &&
          e.clientY <= 0
        ) {
          //console.log('mouse-out-top', shouldFireIntent());
          fireExitIntent('mouse-out-top');
          //alert('exit mouseout');
        }
      });
      if (ENABLED && shouldFireIntent()) {
        window.addEventListener('beforeunload', (e) => {
          fireExitIntent('beforeunload');
          //e.preventDefault();  // Required in Firefox
          //e.returnValue = '';  // Required in Chrome
          fireExitIntent('beforeunload');
        });
      }

    }, TIMEOUT); 
  });
  function handleSMSClick() {
    const isMobileBody = document.body.classList.contains('mobileBody');
    const onlineHours = document.body.getAttribute('data-online');
    if (isMobileBody) {
      if (onlineHours === 'true') {
        window.location.href = ONLINE_SMS;
      }
      if (onlineHours === 'false') {
        window.location.href = OFFLINE_SMS;
      }  
    } else {
      // desktop
      if (onlineHours === 'true') {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', ONLINE_KL_FORM]);
      } 
      if (onlineHours === 'false') {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', OFFLINE_KL_FORM]);
      }
    }
    return false;
  }
  function handleSMSClickChat() {
    const isMobileBody = document.body.classList.contains('mobileBody');
    const onlineHours = document.body.getAttribute('data-online');

    if (isMobileBody) {
      if (onlineHours === 'true') {
        window.location.href = ONLINE_SMS_CHAT;
      }
      if (onlineHours === 'false') {
        window.location.href = OFFLINE_SMS_CHAT;
      }  
    } else {
      // desktop
      if (onlineHours === 'true') {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', ONLINE_KL_FORM_CHAT]);
      } 
      if (onlineHours === 'false') {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', OFFLINE_KL_FORM_CHAT]);
      }
    }

     gtag('event', 'floating_chat_sms', {
      function_name: 'floating_chat_sms',
      page_location: window.location.href,
      online_hours: onlineHours, 
      mobile: isMobileBody 
    });

    return false;
  }


$(document).ready(function() {
  // Clear old discount session

  getDiscountCode();
  // fetch('/checkout?discount=').then(() => {
  //   getDiscountCode()
  // });

    if (theme.custom.template == 'product') {
    pdpCheckDiscountCode(code)
  }
  


});
 


function getDiscountCode() {

  
  $.getJSON('/cart.js', function(cart) {
    
    if (cart.discount_codes.length > 0) {

      const applicableDiscount = (cart.discount_codes || []).find(d => d.applicable === true);
      if (applicableDiscount) { 
        const code = applicableDiscount.code;
        console.log('checkout discount detected', code); 
        checkDiscountCode(code) 
      }



    } else {
      console.log("No checkout discount detected");  
      var cookieDiscountCode = getDiscountCodeCookie();
      if (cookieDiscountCode != null) {
        console.log("No checkout discount detected, apply "+cookieDiscountCode);  
        // Force Shopify to apply new discount and override old session
        fetch(`/checkout?discount=${cookieDiscountCode}`, { method: 'GET' })
          .then(() => {
            // Re-check discount after Shopify applies it
            checkDiscountCode(cookieDiscountCode) 
        });
      } else {
        checkDiscountCode(cookieDiscountCode) 
      }
    }
    
  });
  
}


function checkDiscountCode(code) {
  theme.custom.appliedDiscountCode = code;
  console.log("Discount applied:", code);
  if (theme.custom.customDiscountToggle == false && theme.custom.appliedDiscountCode == theme.custom.customDiscountCode) {
    //alert('remove discount code');
    clearDiscountCode()
  }

  // banner detection
  if (theme.custom.appliedDiscountCode == $('[data-banner-discount-code]').attr('data-banner-discount-code')) {
    $('[data-banner-discount-code] .discountLink').addClass('void')
    $('[data-banner-discount-code] .discountLink .applied').html(theme.custom.customDiscountCodeApplied);
    if (theme.custom.customDiscountEnded) {
      clearDiscountCode()
    }  
  } 
  

  globalCheckDiscountCode(code);
  if (theme.custom.template == 'product') {
    pdpCheckDiscountCode(code)
  }
}
function clearDiscountCode() {
  
   fetch('/checkout?discount=CLEAR', { method: 'GET' })
        .then(() => {
          //alert('success');
        })
        .catch(() => {
          // CORS error lands here
          //alert('error');
        })
        .finally(() => {
          // ALWAYS runs (success or error)
          location.reload();
        });


}
function getDiscountCodeCookie() {
  const match = document.cookie.match(/(^|;\s*)discount_code=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : null;
}
function pdpCheckDiscountCode(code) {

  const allProductTag = $('[data-pdp-tag]').attr('data-pdp-tag').split(', ');
  
  // automatic discount
  if (theme.custom.autoDiscount && allProductTag.includes(theme.custom.autoDiscountTag)) {
    $('[data-pdp-discount-badge]').html('<strong>'+theme.custom.autoDiscountMsgPDP+'</strong>');
  } 

  // custom discount code
  const prodTypeArr = $('[data-pdp-type]').attr('data-pdp-type').split(', ');
  const setB = new Set(theme.custom.customDiscountProdTypes);
  const hasSimilarities = prodTypeArr.some(type => setB.has(type));

  if (code == theme.custom.customDiscountCode && hasSimilarities) {
     $('[data-pdp-discount-badge]').html('<strong>'+theme.custom.customDiscountAppliedMsgPDP+'</strong>');
  }    
}
function globalCheckDiscountCode(code) {
  var cardInfo = $('[data-card-info]');
  var cardInfoCount = cardInfo.length;
  console.log('cardInfoCount', cardInfoCount);
  if (cardInfoCount > 0) {
    cardInfo.each(function() {
      var pTagArr = $(this).attr('data-ptag').split(', ');
      if (theme.custom.autoDiscount && pTagArr.includes(theme.custom.autoDiscountTag)) {
        $(this).find('.discountBadge').html('<strong>'+theme.custom.autoDiscountMsgPDP+'</strong>');
      } 


      var prodTypeArr = $(this).attr('data-type').split(', ');
      const setB = new Set(theme.custom.customDiscountProdTypes);
      const hasSimilarities = prodTypeArr.some(type => setB.has(type));

      console.log('discount', theme.custom.appliedDiscountCode, hasSimilarities);
      if (theme.custom.appliedDiscountCode != '') {
        if (theme.custom.appliedDiscountCode == theme.custom.customDiscountCode) { 
          if (hasSimilarities) {
            console.log('discount discount discount discount');
            $(this).find('.discountBadge').html('<strong>'+theme.custom.customDiscountAppliedMsgPDP+'</strong>');
          }
        }  
      }



   });   
  }
}
$(document).ready(function(){  
  $('.meganav__list .meganav__link').hover(function(){
    var activeNav = $(this).closest('.meganav__nav'); // Nav Level 1, eg. 'Team Sports'
    var curHandle = $(this).data('handle');
    var activeSubnavItems = $('.nav-prod-cont[data-handle="'+curHandle+'"]',$(activeNav));
    if($(activeSubnavItems).length <= 0){
      activeSubnavItems = $('.nav-prod-cont',$(activeNav)).first();
    }
    $('.nav-prod-cont',$(activeNav)).not($(activeSubnavItems)).addClass('hidden');
    $(activeSubnavItems).removeClass('hidden');
  })
});


$(document).ready(function() {
  recalculatesHeaderHorFixHeader();
});
$(window).on('load', function() {
    // Code to run when the window is fully loaded
  recalculatesHeaderHorFixHeader();
});
$('body').on('click', '.navbar-toggler', function() {
  requestAnimationFrame(() => {
    document.body.classList.toggle('drawer-open-left');
  });
});
$('body').on('click', '.site-header__search-submit', function() {
  $('.navbar-toggler').trigger('click');
  $('.drawer__search-input[type="search"]').focus();
});
$('body').on('click', '.close-drawer, .nav--overlay', function() {
  $('body').removeClass('drawer-open-left');
});
$(document).on('keydown', function(event) {
  if (event.key == "Escape") {
    if ($('body').hasClass('drawer-open-left')) {
      $('body').removeClass('drawer-open-left')
    }    
  }
}); 
$('body').on('click', '.drawer__nav-toggle', function() {
  
  if ($(this).attr('aria-expanded') == 'false') {
    // expand
    $(this).attr('aria-expanded', true)
    $(this).closest('.top-level').addClass('exp')
    $(this).next('.child').slideDown(300);
  } else {
    //collapse
    $(this).attr('aria-expanded', false);
    $(this).closest('.top-level').removeClass('exp')
    $(this).next('.child').slideUp(300);
  }
 
});


var resizeTimer;
$(window).on('resize', function(e) {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(function() {
  		recalculatesHeaderHorFixHeader();
	}, 300);

});


function recalculatesHeaderHorFixHeader(){
  $('body').css("margin-top",$("#shopify-section-header").height());
  $('.quizSection').css("top",$("#shopify-section-header").height());
  //$('.exitQuiz').css("top",$("#shopify-section-header").height());

  $('.quizSection .quizContent .quizBlock').css("top",$("#shopify-section-header").height());

  var viewportHeight = window.visualViewport
    ? window.visualViewport.height
    : window.innerHeight;

  var headerHeight = $('#shopify-section-header').outerHeight() || 0;
  var finalHeight = (viewportHeight - headerHeight) - 0;
  
  $('.quizSection .quizContent .quizBlock').css('height', finalHeight + 'px');

}
// hto add event
//alert('hto-new.js');
var products = JSON.parse(localStorage.getItem("products")) == null ? [] : JSON.parse(localStorage.getItem("products"));
var product_count = countLocalStorage();

var singleHTOVal = theme.custom.htoSingleProduct;
var singleHTOArr = singleHTOVal.split(', ');
var clearHTOTitle = theme.custom.htoClearHTOTitle;
var clearHTOMsg = theme.custom.htoClearHTOMsg;

var htoFull = false;
var htoTotalCount = 4;

$(document).ready(function() {
  //console.log('hto-new module');
  updateCartCount('load');
  // hto product
  $.each(products, function(index, val) {
    if ($.inArray(val.productname, singleHTOArr) > -1) {   
      htoFull = true;
    }    
  });

  if( product_count>=4  ){  
     htoFull = true;
  }
  if (performance.navigation.type === 2) {
      //.console.log('Page load is initiated by back or forward button');
      // Add your custom logic here
  } else {
    //console.log('Page load is not initiated by back or forward button');
    if (htoFull && theme.custom.htoProductCart == false) {
      //alert('full hto but no product in cart');
      addHTOFromStorageValue(products)
    }
  }
  
});
$(window).on('HTO_Full', function() {
  //alert("hto full");
  //$(".hto_tip_container").find(".content").hide();
  //$(".hto_tip_container").find(".content.full").css('display','flex');
});

$('body').on('change', '.main-product-variants', function() {
  var productID  = $('.mainForm').attr('data-product-id');
  var variantSize = $('.single-option-selector[data-name="Size"]').val();
  var variantColor = $('.single-option-selector[data-name="Color"]').val();
  var prodTitle = $('.product-single__info-wrapper .product-single__title').text();
  var eyeSize = checkEyeSizePDP();
  setTimeout(function() {
    checkHTOPresence(products, productID, variantSize, variantColor, product_count, eyeSize, prodTitle, 'change');  
    checkdisableHTOVariantPDP();
  }, 10);
  
});
function checkdisableHTOVariantPDP() {
  var xHandle = $('.mainForm').attr('data-handle');
  var xColor = $('.selector-wrapper[data-option-name="Color"] select').val();
  var xSize = '';
  if ($('.selector-wrapper[data-option-name="Size"] select').length > 0) {
      xSize = $('.selector-wrapper[data-option-name="Size"] select').val();    
  }
  //console.log(xHandle+'|'+xColor+'|'+xSize);

  $('.productMainBox #add-to-home-tryon-btn').show();
  $('.productMainBox .htoPop').show();
  var htoFlag = true;
  // loop product entry
  $.each(disableHto, function(key, value) {
      var jsonObj = value;
      var jsonArr = Object.keys(jsonObj);
      var handleFlag = false;
      var colorFlag = false;
      var sizeFlag = false;
      // loop json keys
      for (var key in jsonObj) {
          var xKey = key;
          var xVal = jsonObj[key];

          
          if (key.indexOf('handle') > -1) {
              console.log('handle:' + xHandle, xVal, xHandle.indexOf(xVal));
              if (xHandle.indexOf(xVal) > -1) {
                  handleFlag = true;
              }
          } 
          if (key.indexOf('Color') > -1) {
              //console.log('color:' + xVal);
              var xColorArr = xVal.split(', ');
              // check if color is found
              if ($.inArray(xColor, xColorArr) > -1) {
                  colorFlag = true;
              }
          } 
          if (key.indexOf('Size') > -1) {
              if (xVal != '') {
                  var sizeArr = xVal.split(', ');
                  $.each(sizeArr, function(key, value) {
                      console.log('sizeArr:'+value);
                      var sizeSelector = '';
                      sizeSelector += '[data-size="' + value + '"]';
                      //console.log('sizeSelector', sizeSelector, xSize, value); 
                      if (xSize == value) {
                        sizeFlag = true;    
                      }
                      if (xSize == '') {
                        sizeFlag = true;    
                      }
                  });
              } else {
                  // blank size set size flag true
                  sizeFlag = true
              }
          }
      }

      console.log('htoflags', value, handleFlag+'|'+colorFlag+'|'+sizeFlag+'|'+htoFlag); 

      if (handleFlag && colorFlag && sizeFlag && htoFlag) {
          console.log('----------');
          $('.productMainBox #add-to-home-tryon-btn').hide();
          $('.productMainBox .htoPop').hide();
          htoFlag = false;
          //return false;
      } else {
        /*
        if (handleFlag && htoFlag) {
          console.log('++++++++++');
          //$('.productMainBox #add-to-home-tryon-btn').show();
          //$('.productMainBox .htoPop').show();
          //htoFlag = false;
          //return false;
        }
        */
      }
  }); 
}
function checkEyeSizePDP() {
  var variantSize = $('.single-option-selector[data-name="Size"]').val();
  var eyeSize = '';
  if (variantSize != undefined && variantSize != '') {
    if (variantSize.indexOf('[') > -1) {
      eyeSize = variantSize.split(' [')[0];
    } 
    if (variantSize.indexOf('(') > -1) {
      eyeSize = variantSize.split(' (')[1].replace(')', '');
    }
  } else {
    var sizeMapValue = $('.main-product-variants option:selected').attr('data-size-map');
    if (sizeMapValue != '') {
      variantSize = sizeMapValue;
      eyeSize = $('.main-product-variants').attr('data-eye-size');
      
    }
  }
  return eyeSize;  
}

function addToHomeTryOnButton(evt) {
  console.log('hto button click !');  

  var productTitle = $('.mainForm').attr('data-product-title');
  var inHTOArr = $.inArray(productTitle, singleHTOArr);
  var status = $('.customHTOBtn').attr('data-status');
  if (status == 'empty') {
    if (inHTOArr > -1) {
      console.log('single product hto');
      if (countLocalStorage() > 0) {
        //console.log('show remove other hto modal'); 
        Swal.fire({
          title: clearHTOTitle,
          text: clearHTOMsg, 
          showCancelButton: true,
          confirmButtonText: "Add to Home Try-On",
          cancelButtonText: "Cancel",
          type: 'warning',
          reverseButtons: true,
          customClass: {
              cancelButton: 'btn btn-sm btn-remove',
              denyButton: 'btn btn-sm btn-remove',
              confirmButton: 'btn btn-sm btn-primary'
          }   
        }).then(function(hto) {
          if (hto.isConfirmed) {
            //console.log('remove other hto'); 
            $('.customHTOBtn').addClass('loading'); 
            if (theme.custom.htoToolTipFlag) {
              setTimeout(function() {  
                //$('.customHTOBtn').removeClass('loading');
                //pdpHTOTooltip('added');
                localStorage.removeItem('products');
                addToHomeTryOnButtonFunc(evt);
              }, 1500);
            } else {
              //$('.customHTOBtn').removeClass('loading');
              localStorage.removeItem('products');
              addToHomeTryOnButtonFunc(evt);
            } 
          }
        })
      } else {
        if (theme.custom.htoToolTipFlag) {
          $('.customHTOBtn').addClass('loading');
          setTimeout(function() {  
            //$('.customHTOBtn').removeClass('loading');
            //pdpHTOTooltip('added');
            addToHomeTryOnButtonFunc(evt); 
          }, 1500);
        } else {
          //y$('.customHTOBtn').removeClass('loading');
          addToHomeTryOnButtonFunc(evt);
        }  
        
      }
    } else {
     // console.log('add normal hto'); 
      
      $('.customHTOBtn').addClass('loading');
      if (theme.custom.htoToolTipFlag) {
        setTimeout(function() {
          addToHomeTryOnButtonFunc(evt);
        }, 1500);
      } else {
        addToHomeTryOnButtonFunc(evt);
      }  
      
    } 
  } else if (status == 'full') {
    //alert('full');
    pdpHTOTooltip('full');
  } else  {
    //alert('added');
    pdpHTOTooltip('added');
  }
}
function addToHomeTryOnButtonFunc(evt) {
  console.log('addToHomeTryOnButtonFunc');

  var productName = $('.product-single__title').text();
  var variantId = $('.main-product-variants').val();
  var variantSize = $('.single-option-selector[data-name="Size"]').val();
  var frameSize = $('.main-product-variants').data('size-map');
  var imageURL = $('.main-product-variants option:selected').data('image');
  var variantURL = 'https://'+window.location.host+'/products/'+$('.mainForm ').attr('data-handle')+'?variant='+$('.main-product-variants').val();
  var variantColor = $('.single-option-selector[data-name="Color"]').val();
  var chkId  = $('.mainForm').attr('data-product-id');
  var sku = $('.main-product-variants option:selected').data('sku');
  var eyeSize = '';
  var productID  = $('.mainForm').attr('data-product-id');

  if (imageURL === undefined) {
    imageURL = $('.main-product-variants').data('image');
  }

  var sizeVal = $('.selector-wrapper[data-option-name="Size"] select').val();
  if (sizeVal != undefined && sizeVal != '') {
    if (sizeVal.indexOf('[') > -1) {
      eyeSize = sizeVal.split(' [')[0];
    } 
    if (sizeVal.indexOf('(') > -1) {
      eyeSize = sizeVal.split(' (')[1].replace(')', '');
    }
  } else {
    var sizeMapValue = $('.main-product-variants option:selected').attr('data-size-map');
    if (sizeMapValue != '') {
      variantSize = sizeMapValue;
      eyeSize = $('.main-product-variants').attr('data-eye-size');
    } else {
      eyeSize = $('.main-product-variants').attr('data-eye-size');
    }
  }

  //console.log('variantSize:'+variantSize);
  //console.log('eyeSize:'+eyeSize); 


  setLocalStorage(productName,variantId,variantSize,frameSize,imageURL,variantURL,variantColor,chkId,'', sku, eyeSize);

  // Do not change anything in the following two lines
  window.VWO = window.VWO || [];
  VWO.event = VWO.event || function () {VWO.push(["event"].concat([].slice.call(arguments)))};

  // Replace the property values with your actual values
  VWO.event("addHtoPdp", {
    "htoVariant": variantColor+' - '+variantSize,
    "htoproduct": productName
  });
  $.ajaxSetup({ async: false });
  pushHTOTracking(); 
  $.ajaxSetup({ async: true });



  product_count = countLocalStorage();
  //console.log('product_count:'+product_count);

  checkHTOPresence(products, productID, variantSize, variantColor, product_count, eyeSize, productName, 'click'); 

  $.each(products, function(index, val) {
    if ($.inArray(val.productname, singleHTOArr) > -1) {   
      product_count = 4;    
    }    
  });

  if( product_count>=4 ){     
    setTimeout(function() {
      addHTOFromStorageValue(products);
    }, 1500);
    
    //$('.customHTOBtn').removeClass('loading');
  }  else {
    //$('.customHTOBtn').removeClass('loading');
  }
  if (evt == 'page') {
    setTimeout(function() {
      window.location.href = '/cart';  
    }, 600);
  }

}
function addHTOFromStorageValue(products) {
  if (theme.custom.htoProductCart) {
      // hto is already exist
      window.location.href = '/cart';
  } else {
      // hto product not exist
      if (products != null) {
        $('.htoProperty').html('');
        var properties = {};
        $.each(products, function(key, prod) {
            //console.log(prod);
            var pNum = key + 1;
            var pName = prod.productname.replace(' [V2]', '');
            var pColor = ' | ' + prod.variantcolor;
            var pSize = ' | ' + prod.size;
            var pFrameSize = '';
            var pEyeSize = '';
            if (prod.framesize != undefined) {
              pFrameSize = prod.framesize;  
            }
            var pSKU = '';
            if (prod.sku != undefined) {
              pFrameSize = prod.sku;  
              pSKU = prod.sku;
            }

            if (pColor == ' | ' || pColor == ' | undefined') {
                pColor = '';
            }
            if (pSize == ' | ' || pSize == ' | undefined') { 
                pSize = '';
            }
            if (pFrameSize == '') {
                pFrameSize = prod.size;
            }
            if (prod.eyeSize != undefined) {
              pEyeSize = prod.eyeSize;  
            }


            $('.htoProperty').append('<input type="hidden" name="properties[HomeTryOn #'+pNum+']" value="'+pName + pColor + pSize+'" />');

            $('.htoProperty').append('<input type="hidden" name="properties[_HomeTryOn #'+pNum+' URL]" value="'+prod.url+'" />');
            $('.htoProperty').append('<input type="hidden" name="properties[_HomeTryOn #'+pNum+' Image]" value="'+prod.imageurl+'" />');

            if (pFrameSize != '') {
                properties['_HomeTryOn #' + pNum + ' Frame'] = pFrameSize;
                $('.htoProperty').append('<input type="hidden" name="properties[_HomeTryOn #'+pNum+' Frame]" value="'+pFrameSize+'" />');
            } else {
                $('.htoProperty').append('<input type="hidden" name="properties[_HomeTryOn #'+pNum+' Frame]" value="" />');
            }
            if (pSKU != '') {
                properties['_HomeTryOn #' + pNum + ' SKU'] = pSKU;
                $('.htoProperty').append('<input type="hidden" name="properties[_HomeTryOn #'+pNum+' SKU]" value="'+pSKU+'" />');
            } else {
               
            }

            if (pEyeSize != '') {
                properties['_HomeTryOn #' + pNum + ' eyeSize'] = pEyeSize;
                $('.htoProperty').append('<input type="hidden" name="properties[_HomeTryOn #'+pNum+' eyeSize]" value="'+pEyeSize+'" />');
            } else {
               
            }
            $('.htoProperty').append('<input type="hidden" name="properties[_HomeTryOn #'+pNum+' HR]" value="----------" />');
        });
        $('.htoATCForm form').submit();
      }
  }
}
function setLocalStorage(productName,variantId,variantSize,frameSize,imageURL,variantURL,variantColor,chkId,triggerClass, sku, eyeSize) {
  console.log('setLocalStorage');
    if (sku == undefined) {
      var sku = '';
    }
    if (frameSize == undefined) {
      var frameSize = '';
    }
    if (eyeSize == undefined) {
      var eyeSize = '';
    }
    products = JSON.parse(localStorage.getItem("products")) == null ? [] : JSON.parse(localStorage.getItem("products"));
    var product = { uid: createUUID(), productname: productName, variantid: variantId, size:variantSize, framesize:frameSize, imageurl:imageURL, url:variantURL, variantcolor:variantColor, chkid: chkId, sku: sku, eyeSize: eyeSize };
    
    // check if hto is existing in storage
    var found_flag = false;
    $.each(products, function(key, value) {
        if (chkId == value.chkid && variantSize == value.size && variantColor == value.variantcolor) {
            found_flag = true;
            return false;
        }
    });
    // if not push
    if (!found_flag) {
       products.push(product);
    } 
    products = products.slice(-4);

    localStorage.setItem("products", JSON.stringify(products));
    updateCartCount('add storage');
    if ( $.isFunction($.fn.magnificPopup) ) {
      $.magnificPopup.close();
    }
    //HTO add event
  
}  
function checkHTOPresence(obj, productID, variantSize, variantColor, product_count, eyeSize, prodTitle, evt) {
  console.log('checkHTOPresence');
  //console.log(obj);
  var found_flag = false;
  var variantColor = variantColor;
  $.each(obj, function(key, value) {
    var valueColor = value.variantcolor;
    if (variantColor != undefined && valueColor != undefined) {
      variantColor = variantColor.replace(/\W+(?!$)/g, '-').toLowerCase();
      variantColor = variantColor.replace(/\W$/, '').toLowerCase();

      valueColor = valueColor.replace(/\W+(?!$)/g, '-').toLowerCase();
      valueColor = valueColor.replace(/\W$/, '').toLowerCase();
    }
    var vEyeSize = value.eyeSize;
    if (value.eyeSize == undefined) {
      vEyeSize = '';
    }
    if (eyeSize == '' || vEyeSize == '') {
      if (prodTitle == value.productname && variantColor == valueColor) {  
        found_flag = true;
        return false;  
      }
    } else {
      if (prodTitle == value.productname && eyeSize == value.eyeSize && variantColor == valueColor) {
        found_flag = true;
        return false;  
      }
    }
  });

  var htoProductStorage = JSON.parse(localStorage.getItem("products")) == null ? [] : JSON.parse(localStorage.getItem("products"));

  
  if( product_count>=4) {
    htoFull = true;
  }  
  $.each(htoProductStorage, function(index, htoItem) {  
    var pName = htoItem.productname;
    var singleHTOFound = $.inArray(pName, singleHTOArr);
    if (singleHTOFound > -1) {
      htoFull = true;
      htoTotalCount = 1;
    }
  });
  
  $('.btn[id="add-to-home-tryon-btn"]').removeClass('loading'); 
  
  if (found_flag) {
    $('.btn[id="add-to-home-tryon-btn"]').each(function() {
      $(this).find('strong').html(theme.custom.hto_added);
      //$(this).prop('disabled', true);
      $(this).attr('data-status', 'added');
      if (evt == 'click') {
        pdpHTOTooltip('added');
      }
    });
  } else {
    if(htoFull){
      $('.btn[id="add-to-home-tryon-btn"]').each(function() {
        $(this).find('strong').html(theme.custom.htoCartFull);
        //$(this).prop('disabled', true);
        $(this).attr('data-status', 'full');
      });
      if (evt == 'click') {
        pdpHTOTooltip('full');
      }
    } else {
      $('.btn[id="add-to-home-tryon-btn"]').each(function() {
        $(this).find('strong').html(theme.custom.hto_add);
        if (variantAvailable) {
          $(this).attr('data-status', 'empty');
          //$(this).prop('disabled', false);
        }
      });
    }  
  }
  
} 
$(document).on("click", function(event){
  var target = $("#add-to-home-tryon-btn");
  if (!target.is(event.target) && target.has(event.target).length === 0) {
    // Clicked outside of #target
    $('.htoTipBox').closest('.actionEntry').attr('data-tootlip', false);
  }
});
function pdpHTOTooltip(type) {
  if (theme.custom.htoToolTipFlag) {
    var cartLink = '<p><a href="/cart"><strong>View in cart</strong></a></p>';
    if (type == 'added') {
      var counterMsg = product_count+' of '+htoTotalCount;
      $('.htoTipBox').html(theme.custom.htoAddedTip.replace('[htoCounter]', counterMsg)+cartLink).closest('.actionEntry').attr('data-tootlip', true);
    }
    if (type == 'full') {
      $('.htoTipBox').html(theme.custom.htoFullTip+cartLink).closest('.actionEntry').attr('data-tootlip', true);
    }
  } else {
    $('.htoTipBox').remove();
  }  
}
function updateCartCount(event) {
  //alert(event); 
  //console.log('updateCartCount');
  //console.log(event)
  var htoCount = countLocalStorage();
  var itemCount = parseInt($('.site-header__cart-indicator').attr('data-cart-count'))
  var cartCount = itemCount + htoCount;
  


  if (cartCount > 0) {
    $('.site-header__cart-indicator').removeClass('hide').text(cartCount);
    $('#CartPageTotalItems').text(cartCount);
    //console.log('cartCount HTO new');
    //console.log(cartCount);
  } 
  if (event == 'load') { 
    
  } else if (event == 'update cart') {
    var cartTotal = 0;
    $('#CartProducts .cart-product').each(function() {
      cartTotal += parseInt($(this).attr('data-price'));
    });
    if (cartTotal == 0) {
      $('#CartPageTotal').text(theme.custom.cartFree);
    } else {
      $('#CartPageTotal').text(Shopify.formatMoney(cartTotal));
    }
    
  } else if (event == 'remove hto') {
      if (htoCount < 4 && theme.custom.htoProductCart) {
        $.ajaxSetup({
          async: false,
        });
        //alert('remove hto product');
        var xdata = { updates: {} };
        xdata.updates[theme.custom.htoProduct] = 0;
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: xdata,
            dataType: 'json',
            success: function() {
               theme.custom.htoProductCart = false;
            }       
        });
        $.ajaxSetup({
          async: true,
        });
      } 
      checkHTOItem()
  }
  
  
}
function countLocalStorage() {
  var products = JSON.parse(localStorage.getItem("products")) == null ? [] : JSON.parse(localStorage.getItem("products"));
  if( products != null ){
    return products.length; 
  }
  else return 0;
}

function createUUID(){
  // http://www.ietf.org/rfc/rfc4122.txt
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}


$(document).ready(function() {
  $(window).click(function() {
      $('.htoOverlayBox[status="removed"]').attr('status', 'empty');
      $('.htoOverlayBox').removeClass('open');   

  });
  checkHTOItem();  

  // landing page hto validation
  if ($('.template-page .product-single__info-wrapper').length > 0) {
    var productID  = $('.mainForm').attr('data-product-id');
    var variantSize = $('.single-option-selector[data-name="Size"]').val();
    var variantColor = $('.single-option-selector[data-name="Color"]').val();
    var prodTitle = $('.product-single__info-wrapper .product-single__title').text();
    var eyeSize = checkEyeSizePDP();

    setTimeout(function() {
      checkHTOPresence(products, productID, variantSize, variantColor, product_count, eyeSize, prodTitle, 'load');  
    }, 10); 

  }

});
var resizeTimer2;
$(window).on('resize', function() {
  clearTimeout(resizeTimer2);
  resizeTimer2 = setTimeout(function() {
   adjustHTOSize();  
  }, 600);
  
});

/* product grid hto */
// open hto
  var htoTimer;
  var htoTimer2;


  var htoPresentCheck = false;  
  $('body').on('click', '.htoOverlayBox:not([status="disabled"]) > .label', function(event) {
    var htoOverlayBox = $(this).closest('.htoOverlayBox');
    var productCard = $(this).closest('.customCard');
    var htoStatus = htoOverlayBox.attr('status');
    if (htoOverlayBox.attr('status') == 'empty') {
      productCard.find('.c-color-swatches__swatch.active').trigger('mouseover');
      //$('.customCard .c-color-swatches__swatch.active').trigger('mouseover');
      if (htoStatus != htoOverlayBox.attr('status')) {
        htoPresentCheck = true;
      }      
    }  
    // console.log('htoStatus:'+htoStatus);
    // console.log('htoPresentCheck:'+htoPresentCheck);
    
    if (htoPresentCheck == false) {
      // Run code here, resizing has "stopped"
      $(this).closest('.productGrid').find('.htoOverlayBox').removeClass('open');

      if (htoOverlayBox.attr('data-has-size') == 'true') {
        // has size option
        if (htoOverlayBox.attr('status') == 'empty') {
          htoOverlayBox.closest('.htoOverlayBox').toggleClass('open'); 
          var sizeAvailCount = htoOverlayBox.find('.htoSize label').not('.unAvailable').length;
          if (sizeAvailCount == 1) {
            htoOverlayBox.find('.htoSize label').not('.unAvailable').find('input').trigger('click');
          }
          
          //htoOverlayBox.find('.htoSize label input').trigger('click');

        } else if (htoOverlayBox.attr('status') == 'full') {
          if (htoOverlayBox.find('.label input').prop('checked') == true) {
            removeHTO(htoOverlayBox, htoOverlayBox.attr('data-variant-id'));
          } else {
            htoOverlayBox.closest('.htoOverlayBox').toggleClass('open'); 
          }
        } else if (htoOverlayBox.attr('status') == 'added') {
          //remove hto
          removeHTO(htoOverlayBox, htoOverlayBox.attr('data-variant-id'));
        }
      } else {
        // no size option 
        if ($(this).closest('.htoOverlayBox').attr('status') == 'removed') {
          $(this).closest('.htoOverlayBox').attr('status', 'empty')
        }
        if (htoOverlayBox.attr('status') == 'empty') {
          htoOverlayBox.closest('.htoOverlayBox').toggleClass('open'); 
          htoOverlayBox.find('.htoSize label input').trigger('click');
        } else if (htoOverlayBox.attr('status') == 'full') {
          //remove hto
          if (htoOverlayBox.find('.label input').prop('checked') == true) {
            removeHTO(htoOverlayBox, htoOverlayBox.attr('data-variant-id'));
          } else {
            htoOverlayBox.closest('.htoOverlayBox').toggleClass('open'); 
          }
        } else if (htoOverlayBox.attr('status') == 'added') {
          //remove hto
          removeHTO(htoOverlayBox, htoOverlayBox.attr('data-variant-id'));
        }   
      }
    }

    clearTimeout(htoTimer2);
    htoTimer2 = setTimeout(function() {
      htoPresentCheck = false;    
    }, 600);
    adjustHTOSize();   
    event.stopPropagation();
  });
  // hto selection

  $('body').on('click', '.htoSizeSelection .htoSize label input', function() {
      var htoOverlayBox = $(this).closest('.htoOverlayBox');
    
      var xUID = createUUID();
      var productCard = $(this).closest('.customCard');
      var productName = productCard.find('.boost-pfs-filter-product-item-title').text();
      var pc20bFlag = productCard.attr('data-pc02b-flag');
      if (productName == '') {
        productName = productCard.find('.product-card__name').text();  
      }
      var variantSize = $(this).closest('label').attr('data-size');
      var variantSuffix = $(this).closest('label').attr('data-handle');
      if (variantSuffix === undefined) {
        variantSuffix = '';  
      }
      if (pc20bFlag == 'true') {
        variantSuffix = '';
      }
      var variantId = $(this).val(); 
      var imageURL = '';
      
      if (productCard.find('.boost-pfs-filter-product-item-main-image').length > 0) {
        imageURL = productCard.find('.boost-pfs-filter-product-item-main-image').first().attr('data-src').replace('_large.webp?', '.webp?').replace('_large.jpg?', '.jpg?').replace('_large.png?', '.png?').replace('_360x.webp?', '.webp?').replace('_360x.jpg?', '.jpg?').replace('_360x.png?', '.png?').replace(' 360w', '');
      } else {
        imageURL = productCard.find('.product-card__image').first().attr('data-src').replace('_480x480.webp?', '.webp?').replace('_480x480.jpg?', '.jpg?').replace('_480x480.png?', '.png?').replace('_large.webp?', '.webp?').replace('_large.jpg?', '.jpg?').replace('_large.png?', '.png?');        
      }

      if (productCard.find('.swatches-row .selected').length > 0) {
        var variantColor = productCard.find('.swatches-row .selected').attr('aria-label');
        var variantColorHandle = productCard.find('.swatches-row .selected').attr('data-handle');
        var variantURL = productCard.find('.overlayLink').attr('data-href')+variantSuffix+'?color='+variantColorHandle;
      } else {
        if (productCard.find('.swatches-row .active').length > 0) {
          var variantColor = productCard.find('.swatches-row .active').attr('title');
          var variantColorHandle = productCard.find('.swatches-row .active').attr('data-handle');
          var variantURL = productCard.find('.overlayLink').attr('data-href')+variantSuffix+'?color='+variantColorHandle;
        } else {
          var variantURL = productCard.find('.overlayLink').attr('data-href').replace(variantSuffix, '')+variantSuffix;
        }  
        
      }

      var chkId = productCard.attr('data-id');
      var prodTag = htoOverlayBox.attr('data-tag'); 
      if (prodTag === undefined) {
        prodTag = '';
      }

      if (variantSize == 'default') {
        variantSize = '';
      }
      // console.log('prodTag:'+prodTag);
      // console.log('productName:'+productName);
      // console.log('variantId:'+variantId);
      // console.log('imageURL:'+imageURL);
      // console.log('variantURL:'+variantURL);
      // console.log('variantColor:'+variantColor);
      // console.log('chkId:'+chkId);
      // console.log('prodTag:'+prodTag);

      //var variantJSON = $(this).closest('.product-card').find('.variantJson').html();
      //console.log('variantJSON');
      //console.log(JSON.parse(variantJSON));



      var eyeSize = $(this).closest('label').attr('data-eye-size');
      var prodSKU = $(this).closest('label').attr('data-sku');




      var inHTOArr = $.inArray(productName, singleHTOArr);
      if (inHTOArr > -1 ) {
        if (countLocalStorage() > 0) {
          $('.htoOverlayBox').removeClass('open');    
          Swal.fire({
            title: clearHTOTitle,
            text: clearHTOMsg, 
            showCancelButton: true,
            confirmButtonText: "Add to Home Try-On",
            cancelButtonText: "Cancel",
            type: 'warning',
            reverseButtons: true,
            customClass: {
                cancelButton: 'btn btn-sm btn-remove',
                denyButton: 'btn btn-sm btn-remove',
                confirmButton: 'btn btn-sm btn-primary'
            }   
          }).then(function(hto) {
            if (hto.isConfirmed) {
              //console.log('remove other hto'); 
              //htoOverlayBox.attr('status', 'full'); 
              //$('body').addClass('ajaxLoading'); 
              
              setTimeout(function() {
                $('.htoOverlayBox').removeClass('open');   
                htoOverlayBox.addClass('open');
                localStorage.removeItem('products');
                addHTO(productName,variantId,variantSize,imageURL,variantURL,variantColor,chkId,prodTag, eyeSize, prodSKU);
                htoOverlayBox.attr('status', 'added');   
              }, 300);
            }
          });
        } else {
          addHTO(productName,variantId,variantSize,imageURL,variantURL,variantColor,chkId,prodTag, eyeSize, prodSKU);
          htoOverlayBox.attr('status', 'added'); 
        }  
      } else {
        addHTO(productName,variantId,variantSize,imageURL,variantURL,variantColor,chkId,prodTag, eyeSize, prodSKU);
        htoOverlayBox.attr('status', 'added'); 
      }

      
      
  });


  // close hto
  $('body').on('click', '.htoOverlayBox', function() {
    $('.htoOverlayBox').removeClass('open');    
    $(this).closest('.htoOverlayBox').addClass('open');
  });
  $('body').on('click', '.htoOverlayBox .htoPop', function(event) {
      event.stopPropagation(); 
  });

  $('body').on('click', '.closeHTO ', function() {
      $('.htoOverlayBox').removeClass('open');   
      if ($(this).closest('.htoOverlayBox').attr('status') == 'removed') {
        $(this).closest('.htoOverlayBox').attr('status', 'empty')
      }
  });



function checkHTOItem() {
  const rawStorage = localStorage.getItem("products");
  const htoProductStorage = rawStorage ? JSON.parse(rawStorage) : [];
  const product_count = htoProductStorage.length;
  const htoTotal = 4;
  const htoTipHTML = '<div class="htoTip"><div>Add to your Home Try-On</div></div>';
  const htoFull = (product_count >= htoTotal || singleHTOArr.some(item => htoProductStorage.map(p => p.productname).includes(item)));

  const $htoOverlayBoxes = $('.htoOverlayBox');
  const $htoLabels = $('.htoSizeSelection .htoSize label input');

  // Reset state
  $htoOverlayBoxes.find('> .label input').prop('checked', false);
  $htoLabels.prop('checked', false);
  $htoOverlayBoxes.attr('data-variant-id', '');
  $htoOverlayBoxes.not('[status="disabled"]').attr('status', 'empty');
  $htoOverlayBoxes.find('.hto_count').text(product_count);
  $htoOverlayBoxes.find('.hto_max').text(htoTotal);
  $htoOverlayBoxes.find('.htoSelectedSize').text('');

  // Update product cards
  for (const htoItem of htoProductStorage) {
    const htoTitle = htoItem.productname;
    const variantColor = sanitize(htoItem.variantcolor || '');

    const $pCard = $(`.htoOverlayBox[data-title="${htoTitle}"]`).closest('.product-card');
    const $overlayBox = $pCard.find('.htoOverlayBox');
    let selectedColor = $pCard.find('.swatches-row .selected').attr('aria-label') || $pCard.find('.swatches-row .active').attr('title') || '';
    selectedColor = sanitize(selectedColor);

    if (selectedColor === variantColor) {
      const $sizeCheckbox = $pCard.find(`.htoSize label[data-eye-size="${htoItem.eyeSize}"] input`);
      $sizeCheckbox.prop('checked', true);
      $overlayBox.find('.label input').prop('checked', true);
      $overlayBox.attr({ 'status': 'added', 'data-variant-id': htoItem.variantid });

      const $present = $overlayBox.find('.htoPresent');
      if (!htoItem.size) {
        $present.html('Added to your try at home');
      } else {
        $present.html(`Size: <span class="htoSelectedSize">${htoItem.size}</span> <span>is in your try at home </span>`);
      }
    }
  }

  // Tip message
  $('.htoOverlayBox .htoTip').remove();
  if (product_count === 0) {
    $('.htoOverlayBox').first().append(htoTipHTML);
  }

  // Set full status
  if (htoFull) {
    $htoOverlayBoxes.not('[status="disabled"]').attr('status', 'full');
  }

  // Update cart count
  const itemCount = parseInt($('.site-header__cart-indicator').attr('data-cart-count'), 10) || 0;
  const cartCount = itemCount + product_count;
  const $cartIndicator = $('.site-header__cart-indicator');
  if (cartCount > 0) {
    $cartIndicator.removeClass('hide').text(cartCount);
  } else {
    $cartIndicator.addClass('hide').text(cartCount);
  }

  function sanitize(str) {
    return str.replace(/\W+(?!$)/g, '-').replace(/\W$/, '').toLowerCase();
  }
}


function addHTO(productName,variantId,variantSize,imageURL,variantURL,variantColor,chkId, prodTag, eyeSize, sku){
  //alert('addHTO'); 
  //console.log('addHTO'); 
  // validate
  var htoProductStorage = JSON.parse(localStorage.getItem("products")) == null ? [] : JSON.parse(localStorage.getItem("products"));   
  var product = { uid: createUUID(), productname: productName, variantid: variantId, size:variantSize, imageurl:imageURL, url:variantURL, variantcolor:variantColor, chkid: chkId, prodTag: prodTag, eyeSize: eyeSize, sku: sku};
  htoProductStorage.push(product);
  var product_count = htoProductStorage.length;
  localStorage.setItem("products", JSON.stringify(htoProductStorage));
  
  products = JSON.parse(localStorage.getItem("products")) == null ? [] : JSON.parse(localStorage.getItem("products")); 


  $.ajaxSetup({ async: false });
  pushHTOTracking(); 
  $.ajaxSetup({ async: true }); 
  
  $(window).trigger("HTO_Added");

  var htoTitle = productName;
  var inHTOArr = $.inArray(htoTitle, singleHTOArr);

  if(product_count >= 4 ){
    htoFull = true;
  } else {
    htoFull = false;
  }  
  if (inHTOArr > -1) {
    htoFull = true;
  }
  //alert(product_count);
  //alert('htoFull:'+htoFull);
  // console.log(singleHTOArr);
  // console.log(inHTOArr);
  // console.log('product_count:'+product_count);
  checkHTOItem();
  if (htoFull) {
    //alert('hto full');
    $('.htoOverlayBox').not('[status="disabled"]').attr('status', 'full');
    htoTimer = setTimeout(function() {
     // window.location.href = '/cart'
     //alert('aaaaaaaaaaaaddHTO');
     //console.log(products);
     addHTOFromStorageValue(products);
    }, 1200);
    //alert('full hto'); 
  } 
  
    

}
function removeHTO(htoOverlayBox, vid)  {
  console.log('removeHTO');


  removeHTOStorage(vid);
  htoOverlayBox.closest('.htoOverlayBox').addClass('open'); 
  htoOverlayBox.attr('status', 'removed');
  htoOverlayBox.find('.htoSize input').prop('checked', false);
  htoOverlayBox.find('.label input').prop('checked', false);

    htoTimer = setTimeout(function() {
      if (htoOverlayBox.attr('data-has-size') == 'true') {
        var sizeAvailCount = htoOverlayBox.find('.htoSize label').not('.unAvailable').length;
        if (sizeAvailCount > 1) {
          htoOverlayBox.attr('status', 'empty');    
        } else {
          htoOverlayBox.removeClass('open'); 
          htoOverlayBox.attr('status', 'empty');  
        }
      } else {
        //htoOverlayBox.removeClass('open'); 
        //htoOverlayBox.attr('status', 'empty');  
      }     
    }, 300);
  
      
}
function removeHTOStorage(vid) {
  console.log('removeHTOStorage');
  var htoProductStorage = JSON.parse(localStorage.getItem("products")) == null ? [] : JSON.parse(localStorage.getItem("products"));
  var vid = vid;
  var removeIndex = '';




  if (htoProductStorage != null) {
      var matchedProduct = $.grep(htoProductStorage, function(n, i) {
          if (n.variantid == vid) {
              removeIndex = i;
          }
          return n.variantid == vid;
      });
      if (matchedProduct.length != 0) {
        htoProductStorage.splice(removeIndex, 1);
        localStorage.setItem('products', JSON.stringify(htoProductStorage));
        $.ajaxSetup({
            async: false,
        });
        var xdata = { updates: {} };
        xdata.updates[theme.custom.htoProduct] = 0;
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: xdata,
            dataType: 'json',
            success: function() {
               theme.custom.htoProductCart = false;
            }       
        });
        $.ajaxSetup({
          async: true,
        });
        checkHTOItem();
      }
  }
}

function adjustHTOSize() {
  $('.htoOverlayBox.open .htoSize').attr('data-col', 2);
  var xheights = $(".htoOverlayBox.open .htoSize label").map(function ()
    {
        return $(this).height();
    }).get();

  var xmaxHeight = Math.max.apply(null, xheights);
  if (xmaxHeight > 35) {
    $('.htoOverlayBox.open .htoSize').attr('data-col', 1);
  } 
}

function pushHTOTracking() {
  if (typeof window._learnq !== 'undefined') {
    if (customerEmail) {
        console.log("Logged-in Customer Email:", customerEmail);
          _learnq.push(['identify', {
          "$email": customerEmail
      }]);
      var products = JSON.parse(localStorage.getItem("products")) == null ? [] : JSON.parse(localStorage.getItem("products"));
      if (products.length > 0) {
        var htoStatus = 'incomplete';
        var metricName = 'Custom Incomplete HTO Tracking';
        if (products.length == 4) {
          htoStatus = 'complete';
          metricName = 'Custom Completed HTO Tracking';
        } 
        var prodNames = [];
        var colorNames = [];
        var eyeSizes = [];
        var items = [];
        $.each(products, function(index, val) {
            prodNames.push(val.productname);
            colorNames.push(val.variantcolor);
            eyeSizes.push(val.eyeSize);
        });
        _learnq.push(['track', metricName, {
          "htoStatus": htoStatus,
          "prodNames": prodNames, 
          "colorNames": colorNames,  
          "eyeSizes": eyeSizes,  
          "items": products 
        }]);
      }
    } 
  } 
}



